import { Close } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { Toaster, toast } from 'sonner';

export const SuccessToast = (
    message: (() => React.ReactNode) | React.ReactNode
) => {
    toast.success(message, {
        duration: 2000,
        cancel: (
            <IconButton
                aria-label="close"
                size="small"
                onClick={() => toast.dismiss()}
            >
                <Close fontSize="small" />
            </IconButton>
        ),
    });
};

export const ErrorToast = (
    message: (() => React.ReactNode) | React.ReactNode
) => {
    toast.error(message, {
        duration: 4000,
        cancel: (
            <IconButton
                aria-label="close"
                size="small"
                onClick={() => toast.dismiss()}
            >
                <Close fontSize="small" />
            </IconButton>
        ),
    });
};

export const LoadingToast = (state = true) => {
    if (state === true) {
        toast.loading('Loading...');
    } else {
        toast.dismiss();
    }
};

export const ToasterContainer = () => {
    return <Toaster richColors position="top-center" />;
};
